/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsComponents_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
    readonly " $refType": "SbRespCollectionsComponents_shippingFilters";
}>;
export type SbRespCollectionsComponents_shippingFilters$data = SbRespCollectionsComponents_shippingFilters;
export type SbRespCollectionsComponents_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: SbRespCollectionsComponents_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_shippingFilters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters",
      "args": null
    }
  ]
};
(node as any).hash = '441114fb61af5387249e29d8712705a4';
export default node;
